import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"


const PROPERTY = "ctaText"

export const schema = Validation.string("This is required")


const CtaText = ({name, schedule, onChange, label, ...props}) => (
  <Input
    {...props}
    id={id(name, props)}
    name={name}
    value={get(schedule, name)}
    onChange={(value) => onChange(schedule, name, value)}
    label={label} />
)

CtaText.propTypes = {
  schedule: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  label: PropTypes.string,
  validation: PropTypes.object,
  hint: PropTypes.string,
  name: PropTypes.string
}

CtaText.defaultProps = {
  required: true,
  label: "Call to action text",
  hint: null,
  validation: schema,
  name: PROPERTY
}

export default CtaText
